import { useTranslation } from 'react-i18next'

import { useAsyncCallback } from '../../../../hooks'
import { ConfirmationModal } from '../../../Confirmation'
import { getDocFlowSendingEpostServerErrors } from '../../DocFlowSending'
import { useDocFlowContext } from '../useDocFlowContext'

export function useDocFlowHandleFinish({ onReloadProcess }) {
  const {
    handleCloseModal,
    handleNextPhase: onNextPhase,
    setModal,
  } = useDocFlowContext()

  const { t } = useTranslation()

  function handleSubmitConfirmModal() {
    onReloadProcess().finally(() => {
      handleCloseModal()
    })
  }

  const handleNextPhase = useAsyncCallback(() => {
    return onNextPhase().catch(error => {
      setModal(
        <ConfirmationModal
          actionButtonsProps={{
            Cancel: null,
            submitText: t('Modal.ConfirmBtnKey'),
          }}
          description={getDocFlowSendingEpostServerErrors(error)}
          loading={false}
          title={t('Modal.ErrorTitleKey')}
          onCancel={handleCloseModal}
          onSubmit={handleSubmitConfirmModal}
        />
      )
    })
  }, [handleCloseModal, handleSubmitConfirmModal, onNextPhase, setModal, t])

  return {
    handleNextPhase,
  }
}
